<!-- 供货名称选择器 -->
<template>
    <xx-select
        v-model="innerValue"
        :list="supplierList"
        :clearable="false"
        :filterable="true"
        :useScroll="true"
        class="supplier-select"
        placeholder="请选择供货规则"
        @change="onChange"
    />
</template>

<script>
import {
    defineComponent, reactive, toRefs, computed, getCurrentInstance,
} from '@vue/composition-api';

export default defineComponent({
    name: 'SupplierName',
    props: {
        value: {
            type: [String, Number],
            default: '',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
    },
    setup(props, { emit }) {
        const { proxy: vm } = getCurrentInstance();
        const data = reactive({
            innerValue: computed({
                get: () => props.value,
                set: (val) => emit('input', val),
            }),
            supplierList: [],
            onChange: (val, node) => {
                emit('change', val, node);
            },
        });

        const getSupplierList = async () => {
            const res = await vm.$hGet('/api/vss/second/shepherd/supplier/query/supplier-list');
            data.supplierList = (res || []).map((item) => ({ value: item.supplierId, label: item.supplierName }));
            emit('loaded', data.supplierList);
        };
        getSupplierList();

        return {
            ...toRefs(data),
        };
    },
});
</script>
